import { Link } from '@tanstack/react-router';
import { Bell, TrendingUp } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { track } from '@/lib/mixpanel';

type AIAlertPromoCardProps = {
  position: number;
};

const promoVariants = [
  {
    title: 'Te-ai săturat să dai scroll?',
    description:
      'Setează alerte personalizate și lasă AI-ul să îți aducă știrile relevante direct.',
  },
  {
    title: 'Nu mai rata nicio veste importantă',
    description:
      'Configurează alerte AI pentru acțiunile tale preferate și primești notificări instant.',
  },
];

export function AIAlertPromoCard({ position }: AIAlertPromoCardProps) {
  // Alternate icon and text based on position
  const variantIndex = position % 2;
  const Icon = variantIndex === 0 ? TrendingUp : Bell;
  const { title, description } = promoVariants[variantIndex];

  const handleClick = () => {
    track('AIAlertPromoCard_Clicked', { position });
  };

  return (
    <Card className="w-full overflow-hidden border-green-primary/20 bg-gradient-to-r from-green-primary/10 via-green-primary/5 to-white shadow-sm transition-all duration-200 hover:shadow-md">
      <div className="flex flex-col items-start justify-between gap-4 p-4 sm:flex-row sm:items-center md:p-6">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0 rounded-xl bg-green-primary/15 p-3">
            <Icon className="h-6 w-6 text-green-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-black">{title}</h3>
            <p className="text-sm text-neutral-700">{description}</p>
          </div>
        </div>
        <Button
          variant="outline"
          className="flex-shrink-0 border-green-primary text-green-primary hover:bg-green-primary hover:text-white"
          asChild
          onClick={handleClick}>
          <Link to="/create-alert">Află mai multe</Link>
        </Button>
      </div>
    </Card>
  );
}
